module.exports = {"411702001":"人民街道","411702002":"东风街道","411702003":"西园街道","411702004":"新华街道","411702005":"南海街道","411702006":"老街街道","411702007":"橡林街道","411702008":"雪松街道","411702009":"顺河街道","411702010":"刘阁街道","411702011":"香山街道","411702100":"水屯镇","411702101":"沙河店镇","411702102":"板桥镇","411702103":"诸市镇","411702104":"蚁蜂镇","411702201":"老河乡","411702204":"朱古洞乡","411702205":"胡庙乡","411702206":"古城乡","411702561":"金桥街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411702.json
// module id = 1538
// module chunks = 0